import Truncate from 'react-truncate';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { MentoringProgramEnrollment } from 'redux/schemas/models/mentoring-program-enrollments';
import { getMentoringProgramEnrollment } from 'redux/selectors/mentoring-program-enrollments';
import WorkspaceTitle from './workspace-title';

const HeaderMainContent = ({
  mentoringProgram,
  renderProgramDates,
  showBackMyMentees,
  currentUser,
  connectionUser,
  isParticipant,
}) => {
  const isMatchDateFuture = moment(
    mentoringProgram?.matchAnnouncementDate
  ).isAfter(moment());

  const isClosed = mentoringProgram?.endDate && moment().isAfter(moment(mentoringProgram.endDate));
  const isReleased = mentoringProgram?.releasedDate && moment().isAfter(moment(mentoringProgram.releasedDate));
  const matchAnnouncementDateIsPast = mentoringProgram?.matchAnnouncementDate && moment().isAfter(moment(mentoringProgram.matchAnnouncementDate));

  const showWorkspaceTitle = isParticipant && connectionUser && !isMatchDateFuture && !isClosed && isReleased && matchAnnouncementDateIsPast;
  const menteesAlias = mentoringProgram?.programAlias?.mentee?.downcasedPluralized;

  return (
    <div className='main'>
      {!isParticipant && (
        <div className='d-flex align-items-end date-container'>
          {renderProgramDates()}
        </div>
      )}
      <div className='w-50'>
        <Truncate lines={3} ellipsis='...' className='heading-1'>
          {mentoringProgram?.name}
        </Truncate>
      </div>
      {!isParticipant && (
        <div className='w-50'>
          <Truncate
            lines={3}
            ellipsis='...'
            className='text-large-body main-description'
          >
            {mentoringProgram?.description}
          </Truncate>
        </div>
      )}
      {showWorkspaceTitle && (
        <WorkspaceTitle
          currentUser={currentUser}
          connectionUser={connectionUser}
          showGoBack={showBackMyMentees}
          menteesAlias={menteesAlias}
        />
      )}
    </div>
  );
};

export default HeaderMainContent;
